<template>
  <div class="loginPage">
    <v-row dense no-gutters class="auth-row">
     <v-col cols="12" sm="12" md="6" class="custom-height">
        <div class="auth-light-version">
          <div class="logo">
            <v-img :width="logoWidth" :height="logoHeight" :src="logoSrc"></v-img>
          </div>
          <h3>Create New Account</h3>
          <div class="wrapper-box">
            <v-card-text class="pa-0 account-type-title"
              >Please Choose Your Account Type First</v-card-text
            >
            <div class="account-login-links">
              <v-card
                :ripple="false"
                color="transparent"
                outlined
                tile
                :value="registerInfo.owner_type === 1"
                @click="REGISTER_ACCOUNT_TYPE('Individual')"
                :class="
                  registerInfo.owner_type === 1
                    ? 'widgets-card-reg border-active'
                    : 'widgets-card-reg'
                "
              >
                <v-btn class="mx-2 mb-3" fab link small elevation="0" color="#039de9">
                  <v-icon color="#fff"> mdi-account-outline </v-icon>
                </v-btn>
                <p class="mb-0">Individual</p>
              </v-card>
              <v-card
                :ripple="false"
                color="transparent"
                outlined
                tile
                :value="registerInfo.owner_type === 2"
                @click="REGISTER_ACCOUNT_TYPE('Company')"
                :class="
                  registerInfo.owner_type === 2
                    ? 'widgets-card-reg border-active'
                    : 'widgets-card-reg'
                "
              >
                <v-btn class="mx-2 mb-3" fab link small elevation="0" color="#039de9">
                  <v-icon color="#fff"> mdi-home-outline </v-icon>
                </v-btn>
                <p class="mb-0">Company</p>
              </v-card>
            </div>
            <v-btn
              class="mx-auto text-capitalize btn-account"
              color="#039de9"
              tile
              elevation="0"
              @click="nextPage"
              :disabled="!allConditionsMet"
            >
              Next
            </v-btn>

            <div class="another-link">
              <p>
                Already have an account?
                <router-link to="/">Log in</router-link>
              </p>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="12" md="6" class="image-col">
        <div class="image-content">
          <h3 class="mb-2">High Risk Investment Warning:</h3>
          <p>
            Trading Leveraged Products such
            as Forex and Derivatives may not be suitable for all investors as they carry a
            high degree of risk to your capital. Please ensure that you fully understand
            the risks involved, taking into account your investments objectives and level
            of experience, before trading, and if necessary, seek independent advice.
          </p>
          <social-icons :info="genInfo"></social-icons>
        </div>
        <div class="image-container">
          <v-img src="@/assets/auth.png" class="zoom-animate-full image-full"></v-img>
        </div>
      </v-col>
    </v-row>
    
  </div>
</template>

<script>
import LanguageMenu from "@/components/TopBar/LanguageMenu.vue";
import { PUBLIC_LOGIN__ACTIONS } from "@/store/action-types";
import { mapActions, mapMutations, mapState } from "vuex";
import SocialIcons from "../auth/SocialIcons.vue";

export default {
  name: "CreateAccount",
  components: { LanguageMenu, SocialIcons },
  data() {
    return {
      genInfo: {},
    }
  },

  computed: {
    ...mapState("register", ["registerInfo"]),
    ...mapState("publicinfo", ["info"]),

    allConditionsMet() {
      return this.registerInfo.owner_type;
    },

    logoSrc() {
      return this.$vuetify.theme.light ? this.info?.logo_url : this.info?.logo_url_dark;
    },

    companyName() {
      return this.info?.company_name || "Forex Crm"; // Changed from generalInfo to info
    },

    logoWidth() {
      return this.info?.logo_width || "50px"; // Changed from generalInfo to info
    },

    logoHeight() {
      return this.info?.logo_height || "50px"; // Changed from generalInfo to info
    },
  },

  methods: {
    ...mapMutations("register", [
      "REGISTER_ACCOUNT_TYPE", "RESET" ,
    ]),

    ...mapActions("publicinfo", [PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]),

    nextPage() {
      this.RESET();
      this.$router.push("/registration");
    },
  },

  async mounted() {
    this.genInfo = this.info || {};
    await this[PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]();
    document.title = "Create Account";
  },
  async created() {
    this.genInfo = this.info || {};
  },
};
</script>

<style scoped>
.widgets-card-reg{
  width: 170px;
  min-height: 150px !important;
  border: 1px solid #4a5d73 !important;
  margin: 0 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.border-active{
  border-color: #039de9 !important;
}
</style>
